/* CartX full-page cover wheel */
(function () {
  'use strict';

  var CONFIG = {
    coverSelector:
      '#cartx-wrap .cartx-a[data-form-id="1440cc1f6469465c8a79f736ce229878"] .cartx-b-wheel-container__start .cartx-b-cover',
    wheelImageUrl:
      'https://cdn.shopify.com/s/files/1/0627/9662/8192/files/111_81378e9e-bac5-4a62-88d0-1eb631e23f69.png?v=1786513532',
    centerImageUrl:
      'https://cdn.shopify.com/s/files/1/0627/9662/8192/files/333.png?v=1786513536',
    // Positive CSS rotation is clockwise. Stop 15 degrees clockwise from start.
    stopAngle: 15,
    extraTurns: 5,
    duration: 4800
  };

  var INITIALIZED_ATTRIBUTE = 'data-cartx-cover-wheel-initialized';

  function isVisible(element) {
    if (!element || !element.isConnected) {
      return false;
    }

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function createWheel(cover) {
    if (!cover || cover.hasAttribute(INITIALIZED_ATTRIBUTE)) {
      return;
    }

    cover.setAttribute(INITIALIZED_ATTRIBUTE, 'true');
    cover.classList.add('cartx-custom-wheel-cover');

    var content = document.createElement('div');
    var title = document.createElement('div');
    var subtitle = document.createElement('p');
    var wrapper = document.createElement('div');
    var wheel = document.createElement('button');
    var disk = document.createElement('img');
    var center = document.createElement('span');
    var centerImage = document.createElement('img');
    var pointer = document.createElement('span');

    content.className = 'cartx-custom-wheel-cover__content';
    title.className = 'cartx-custom-wheel-cover__title';
    title.textContent = 'Unlock your travel upgrade';
    subtitle.className = 'cartx-custom-wheel-cover__subtitle';
    subtitle.textContent = 'Click on the globe to win a discount';

    wrapper.className = 'cartx-custom-wheel-wrap cartx-custom-wheel-wrap--cover';
    wheel.type = 'button';
    wheel.className = 'cartx-custom-wheel';
    wheel.setAttribute('aria-label', 'Spin the wheel');

    disk.className = 'cartx-custom-wheel__disk cartx-custom-wheel__disk--image';
    disk.src = CONFIG.wheelImageUrl;
    disk.alt = '';
    disk.draggable = false;

    center.className = 'cartx-custom-wheel__center';
    centerImage.className = 'cartx-custom-wheel__center-image';
    centerImage.src = CONFIG.centerImageUrl;
    centerImage.alt = '';
    centerImage.draggable = false;
    center.appendChild(centerImage);

    pointer.className = 'cartx-custom-wheel__pointer';

    wheel.appendChild(disk);
    wheel.appendChild(center);
    wrapper.appendChild(wheel);
    wrapper.appendChild(pointer);
    content.appendChild(title);
    content.appendChild(subtitle);
    content.appendChild(wrapper);
    cover.appendChild(content);

    var currentRotation = 0;
    var spinning = false;

    wheel.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (spinning || !cover.isConnected) {
        return;
      }

      spinning = true;
      wheel.disabled = true;

      currentRotation += CONFIG.extraTurns * 360 + CONFIG.stopAngle;
      disk.style.transform = 'rotate(' + currentRotation + 'deg)';

      var completed = false;

      function continueToNextPage() {
        if (completed) {
          return;
        }

        completed = true;
        disk.removeEventListener('transitionend', onTransitionEnd);
        window.clearTimeout(fallbackTimer);

        window.requestAnimationFrame(function () {
          // Text and wheel share this container, so both disappear together.
          content.hidden = true;
          content.setAttribute('aria-hidden', 'true');

          // Trigger CartX's original full-page navigation behavior.
          cover.click();
        });
      }

      function onTransitionEnd(event) {
        if (event.propertyName === 'transform') {
          continueToNextPage();
        }
      }

      var fallbackTimer = window.setTimeout(
        continueToNextPage,
        CONFIG.duration + 150
      );

      disk.addEventListener('transitionend', onTransitionEnd);
    });
  }

  function scanForCover() {
    var cover = document.querySelector(CONFIG.coverSelector);

    if (isVisible(cover)) {
      createWheel(cover);
    }
  }

  function start() {
    scanForCover();

    var observer = new MutationObserver(function () {
      scanForCover();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    window.setTimeout(scanForCover, 500);
    window.setTimeout(scanForCover, 1500);
    window.setTimeout(scanForCover, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
